const prepareValidation = (field) => {
  const validationRules = [];
  if (field.is_mandatory) {
    validationRules.push('required');
  }
  if (field.regex_pattern) {
    validationRules.push('regex');
  }
  const isOptional = !field.is_mandatory && validationRules.length > 0;
  const validation = isOptional
    ? ['optional', ...validationRules].join('|')
    : validationRules.join('|');
  return {
    validation,
    validation_rules: field.regex_pattern
      ? {
          regex: ({ value }) => new RegExp(field.regex_pattern).test(value),
        }
      : {},
    validation_messages: field.regex_pattern && {
      regex:
        field.regex_message || `Value must fit RegEx: ${field.regex_pattern}`,
    },
    help: field.regex_pattern && field.regex_hint,
  };
};

const prepareOptions = (type, values) => {
  switch (type) {
    case 'radio':
      return Object.fromEntries(values.map((v) => [v.value, v.value]));
    case 'select':
      return values.map(({ value }) => ({
        label: value,
        value,
      }));
    default:
      return null;
  }
};

export const prepareSchema = (schema) =>
  schema.map((field) => ({
    ...field,
    options: prepareOptions(field.ui_input, field.white_list),
    placeholder: field.white_list.length ? `Select ${field.name}` : '',
    ...prepareValidation(field),
  }));
